import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ServerBackendCodesComponent } from '../server-backend-codes/server-backend-codes.component';

@Component({
  selector: 'app-server-backend-list',
  templateUrl: './server-backend-list.component.html',
  styleUrls: ['./server-backend-list.component.css']
})
export class ServerBackendListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public username: string;
  public server: string;
  public lang: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public task_type: number;
  public confirm_delete: boolean;
  public count_total: number; public page_number_first: number; public page_number_second: number; public page: number = 1;
  public code: any;
  public type: number; public type_search: number;
  @ViewChild('myModal') myModal: any; @ViewChild('myModalSearch') myModalSearch: any;
  public pattern_title_with_persian: any;
  //******************************************************************************
  public obj = {};
  public data = {};
  public list_record: any = [];
  public list_status: any = [];
  //******************************************************************************
  public id: number;
  public pre_status: boolean; public next_status: boolean; public new_status: boolean;
  public status_id: number;
  public title: string; public title_search: string;
  //************
  //***********
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  dataSource;
  displayedColumns = ['row', 'title', 'status', 'id', 'operation'];
  //*************
  constructor(public serverService: ServerService, public dialog: MatDialog,
    public ngxSmartModalService: NgxSmartModalService, public router: Router, public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    )
    this.serverService.status1(2);
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.username = JSON.parse(<any>localStorage.getItem('username'));
    this.pattern_title_with_persian = this.serverService.pattern_title_with_persian();
    this.recieve_status();
    this.load_data(1);
  }//end ngOnInit
  //****************************************************************************
  load_data(page) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    this.subscription = this.serverService.post_address(this.server, 'project_service_init_list', { "page": this.page, 'type': this.type, 'title': this.title_search }).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {
          this.list_record = [];
          for (var i = 0; i < this.data['num']; i++) {
            this.list_record.push(this.data['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.count_total = res['count'];
          this.page_number_first = this.page * 20 - 19;
          this.page_number_second = this.page * 20;
          if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
          else { this.pre_status = false; this.new_status = true; }
          if (this.data['num'] < 20) { this.page_number_second = this.count_total; this.next_status = true }//end if
          else { this.next_status = false; }
          this.myModal.close();
          this.myModalSearch.close();
          this.serverService.change_window_resize(2, 'box_process', 0);
          this.recieve_erorr(false, false, "", "", 1);
        }//end if
        else {
          this.recieve_erorr(true, true, 'Erorr in recieve', "خطا در دريافت", 1);
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  //***************************************************************************
  change_task(type, id, title, status_id) {
    this.task_type = type;
    this.id = id;
    if (type == 1) {
      this.title = "";
      this.status_id = 1;
      this.type = 1;
      this.myModal.open();
    }//end if
    if (type == 2) {
      this.title = title;
      this.status_id = status_id;
      this.myModal.open();
    }//end else
    if (type == 3) {
      this.type = 3;
      this.myModalSearch.open();
    }
  }//end change_task

  get_bg(id) {
    this.id = id;
  }
  //***************************************************************************
  insert() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'project_service_init_new', { "username": this.username, 'status_id': this.status_id, 'title': this.title }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_record.unshift(res['result'][0]);
          this.count_total = this.count_total + 1;
          if (this.count_total > 20) {
            this.list_record.pop();
            this.next_status = false;
          }//end if
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.id = res['result'][0].project_service_id;
          this.recieve_erorr(false, false, "", "", 1);
        }//end if
        else if (res['status'] == 4) {
          if (this.lang == '1') {
            alert(' عنوان  مي بايست منحصر به فرد باشد ');
          }//end if
          if (this.lang == '2') {
            alert('The title should be unique');
          }//end if 
          this.recieve_erorr(false, false, "", "", 1);
        }
        else {
          this.recieve_erorr(true, true, 'Erorr in save', "خطا در ذخيره", 1);
        }
      }
    );
  }//end insert
  //********************************************************************************
  update() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'project_service_init_update', { "username": this.username, 'title': this.title, 'status_id': this.status_id, 'id': this.id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < this.list_record.length; i++) {
            if (this.list_record[i].project_service_id == this.id) {
              this.list_record[i].project_service_title = res['result'][0].project_service_title;
              this.list_record[i].status_id = res['result'][0].status_id;
              this.list_record[i].status_title = res['result'][0].status_title;
              this.list_record[i].status_title2 = res['result'][0].status_title2;
            }//end if
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.recieve_erorr(false, false, "", "", 1);
        }//end if
        else if (res['status'] == 4) {
          if (this.lang == '1') {
            alert(' عنوان  مي بايست منحصر به فرد باشد ');
          }//end if
          if (this.lang == '2') {
            alert('The title should be unique');
          }//end if 
          this.recieve_erorr(false, false, "", "", 1);
        }
        else {
          this.recieve_erorr(true, true, 'Erorr in save', "خطا در ذخيره", 1);
        }
      }
    );
  }//end insert
  //********************************************************************************
  delete(id) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.id = id;
    if (this.lang == '1') {
      this.confirm_delete = confirm("آيا شما از حدف اطمينان داريد ؟");
    }//end if
    if (this.lang == '2') {
      this.confirm_delete = confirm("Are you sure for delete");
    }//end if
    if (this.confirm_delete == true) {
      this.loading = true;
      this.subscription = this.serverService.post_address(this.server, 'project_service_init_delete', { "username": this.username, 'id': id, "page": this.page, 'type': this.type, 'title': this.title_search }).subscribe(
        (res) => {
          this.data = res;
          if (this.data['status'] == 1) {
            for (var i = 0; i < this.list_record.length; i++) {
              if (this.list_record[i].project_service_id == id) {
                this.list_record.splice(i, 1);
              }//end if
            }//end for
            if (Object.keys(res['result']).length != 0) {
              this.id = res['result'][0].project_service_id;
              this.list_record.push(res['result'][0]);
            }//end Object.keys
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = this.count_total - 1;
            this.recieve_erorr(false, false, "", "", 1);
          }//end if
          else {
            this.recieve_erorr(true, true, 'Erorr in delete', "خطا در حذف", 1);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //*******************************************************************************
  recieve_status() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.subscription = this.serverService.get_address(this.server, 'get_status').subscribe(
      (res) => {
        this.list_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
          this.recieve_erorr(false, false, "", "", 2);
        }//end if
        else {
          this.recieve_erorr(true, true, 'Erorr in recieve', "خطا در دريافت", 2);
        }
      }
    )
  }//end recieve_status

  open_codes(id) {
    this.dialog.open(ServerBackendCodesComponent, {
      width: '75rem',
      height: 'auto',
      data: { 'id': id }
    })
  }
  //*******************************************************************************
  change_resize() {
    this.serverService.change_window_resize(1, 'box_process', 0);
  }//end change_resize
  //*******************************************************************************
  recieve_erorr(err_validation, loading, en_message, pe_message, type) {
    this.err_validation = err_validation;
    if (type == 1) this.loading = false;
    if (this.lang == 1) { this.err = pe_message; }
    if (this.lang == 2) { this.err = en_message; }
  }//end 

  ModalClose() {
    this.recieve_erorr(false, false, "", "", 2);
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}